export { loyaltyPages } from './pages/loyalty';
export { bookingPage } from './pages/booking';
export { billingPage } from './pages/billing';
